import React from 'react';
import InputField from '../../FormFields/InputField';
import MessageA13 from './MessageA13';



const MessageA14 = (props) => {




    return (
    //     <div> <div className="form-group">
    //     <label className="sel fs14" style={{marginBottom:'10px'}}>{props.item.text}</label>
    //     <input type="text" className="form-control" placeholder="" tabIndex="1" />
    //     <span className="validate">&nbsp;</span> </div>
    // </div>
    <InputField {...props} />
    )
}


export default MessageA14;